import oInfo from "../info.json";

const Footer = () => {
  const { sTitle, sUrl, sUrlText } = oInfo.oFooterPage;
  return (
    <footer className="flex-row flex-center footer">
      <h2 className="footer-text">
        {sTitle}
        <a href={sUrl} className="nrb-link" rel="noreferrer" target="_blank">
          {sUrlText}
        </a>
      </h2>
    </footer>
  );
};

export default Footer;
